const m = window.require("@ember/application/instance");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;